import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastTitleFn = /* @__PURE__ */ createRecipe('toast-title', {}, [])

const toastTitleVariantMap = {}

const toastTitleVariantKeys = Object.keys(toastTitleVariantMap)

export const toastTitle = /* @__PURE__ */ Object.assign(memo(toastTitleFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastTitle',
  __getCompoundVariantCss__: toastTitleFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastTitleVariantKeys,
  variantMap: toastTitleVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastTitleVariantKeys)
  },
  getVariantProps: toastTitleFn.getVariantProps,
})